<div>
  <h3>{{ 'controlRoom.' + schedulerType() + '.sectionTitle' | translate }}</h3>
  <p>{{ 'controlRoom.' + schedulerType() + '.cronSchedule' | translate }}</p>
  <div>
    <div class="spacing--margin-vertical">
      <button
        type="button"
        mat-flat-button
        color="primary"
        [disabled]="enabledState()"
        class="spacing--margin-horizontal"
        (click)="onActivate()"
        data-test="activate-automatic-flow-scheduler-button"
      >
        {{ 'controlRoom.activateButton' | translate }}
      </button>

      <button
        type="button"
        mat-flat-button
        color="primary"
        [disabled]="loading()"
        class="spacing--margin-horizontal"
        (click)="onActivateNow()"
        data-test="trigger-automatic-flow-button"
      >
        {{ 'controlRoom.startNowButton' | translate }}
      </button>

      <button
        type="button"
        mat-flat-button
        color="primary"
        [disabled]="!enabledState()"
        class="spacing--margin-horizontal"
        (click)="onStop()"
        data-test="deactivate-automatic-flow-scheduler-button"
      >
        {{ 'controlRoom.disabledButton' | translate }}
      </button>
    </div>
  </div>
</div>
